
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="考试时间">
              <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="发货状态">
              <a-select v-model="queryParam.is_fahuo" placeholder="请选择"
                        allowClear >
                <a-select-option value="6">已发货</a-select-option>
                <a-select-option value="1">未发货</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="付款状态">
              <a-select v-model="queryParam.pay_status" placeholder="请选择"
                        allowClear >
                <a-select-option value="2">支付成功</a-select-option>
                <a-select-option value="1">未支付</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="审核状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="考试状态">
              <a-select v-model="queryParam.score_status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待考试</a-select-option>
                <a-select-option value="2">考试中</a-select-option>
                <a-select-option value="3">考试结束</a-select-option>
                <a-select-option value="4">确认分数</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">
                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="queryParam.kaojitype"
                    placeholder="类型"
                    allowClear
                >
                  <a-select-option   title="考级中心" value="考级中心">考级中心</a-select-option>
                  <a-select-option   title="考级点" value="考级点">考级点</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间排序">
                <a-select v-model="queryParam.sort_value" allowClear placeholder="请选择" >
                  <a-select-option value="asc">升序</a-select-option>
                  <a-select-option value="desc">倒序</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item label="授权编号">-->
<!--                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->


           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button  v-if="$auth('KaojiApply')"  @click="onSetting" style="margin-left: 8px">
        设置 <a-icon type="setting" />
      </a-button>

      <!-- <a-button @click="onScoreConfirm" style="margin-left: 8px">
        <a-badge :count="scoreTotal">
        待确认分数
        </a-badge>
      </a-button> -->

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}
            <a-tag v-if="record.kaojitype=='考级点'" color="green">
              考级点
            </a-tag>
            <a-tag v-else color="blue">
              考级中心
            </a-tag>
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            申请时间 {{record.create_time|timeFormat}}
            <br/>
            考试时间 {{record.datetitle}}
            <br/>
             加盟类型:
            <a-tag v-if="record.kaoji_jiameng_type==1">老政策</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==2">0元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==3">9800元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==4">12万元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==5">13.5万元</a-tag>
            <a-tag v-else>未知</a-tag>
            <p v-if="record.extra_center && record.extra_center.length>0">考级中心授权:

              <a-tag   color="blue">{{record.extra_center[0].name}}</a-tag>
              </p>
          </div>
      </span>
      <span slot="kaoguan" slot-scope="text,record">
        考官:
        <span v-if="record.kaoguan.length>0">
          <a-tag v-for="user in record.kaoguan">{{user.name}}</a-tag>
        </span>
        <span v-else>无</span>
            <br/>
        监督:
        <span v-if="record.jiandu.length>0">
          <a-tag v-for="user in record.jiandu">{{user.name}}</a-tag>
        </span>
        <span v-else>无</span>

      </span>
      <span slot="jindu" slot-scope="text,record">
<!--        申报-->
<!--        <a-tag v-if="record.status==1" color="red">等待审核</a-tag>-->
<!--        <a-tag v-else-if="record.status==2" color="green">审核成功</a-tag>-->
<!--        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>-->
<!--        <a-tag v-else>未提交</a-tag>-->
<!--        <br/>-->
        物料
        <a-tag v-if="record.goods_status==1"  >选择器材</a-tag>
        <a-tag v-else-if="record.goods_status==2"  >完善收货信息</a-tag>
        <a-tag v-else-if="record.goods_status==3"  >管理员确认金额</a-tag>
        <a-tag v-else-if="record.goods_status==4"  >正在付款</a-tag>
        <a-tag v-else-if="record.goods_status==5" >支付成功   </a-tag>
        <a-tag v-else-if="record.goods_status==6" >已发货</a-tag>
        <a-tag v-else-if="record.goods_status==7" >已安装</a-tag>
        <a-tag v-else-if="record.goods_status==8" color="green">完成</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        缴费
        <a-tag v-if="record.pay_status==1"  >未支付</a-tag>
        <a-tag v-else-if="record.pay_status==2" color="green"  >支付成功</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        结算
        <a-tag v-if="record.cash_status==1"  >未结算</a-tag>
        <a-tag v-else-if="record.cash_status==2" color="green"  >已结算</a-tag>
        <a-tag v-else-if="record.cash_status==3" color="blue"  >结算中</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        <a v-if="record.resultszip && record.resultszip2">成绩已上传</a>
      </span>
      <span slot="action" slot-scope="text,record">
        <template    v-if="$auth('KaojiApply')" >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">人员</a>
          <a-divider type="vertical" />
          <a @click="handleOrderEdit(record)">缴费</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
            >
            <a-input  v-decorator="[
          'danwei',
          {rules: [{ required: true, message: '请输入单位名称' }]}
        ]"
                      placeholder="请输入单位名称"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="时间"
                      hasFeedback
              >
                <a-date-picker
                        v-model="formData.datetitle_moment"
                        format="YYYY-MM-DD"
                        placeholder="考试时间"/>
              </a-form-item>

              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="人数"
                  hasFeedback
          >
            {{formData.members}}
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">

              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="地址"
                  hasFeedback
          >
            <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect
            />
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="考级地址"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入详细地址' }]}
        ]"
                      placeholder="请输入详细地址"/>
          </a-form-item>
            </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
                  label="考核证明文件"
                  hasFeedback
          >
            <file-uploader
                    :file-list="formData.resultszip"
            />

          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="物料邮寄地址"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'address_wuliao',
          {rules: [{ required: true, message: '请输入物料邮寄地址' }]}
        ]"
                          placeholder="请输入物料邮寄地址"/>
              </a-form-item>
            </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系方式"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'phone',
          {rules: [{ required: true, message: '联系方式' }]}
        ]"
                          placeholder="请输入联系人"/>
              </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入联系人' }]}
        ]"
                          placeholder="请输入联系人"/>
              </a-form-item>
            </a-col>
            </a-row>

          <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考官"
                      hasFeedback
              >
                <div v-for="(user,index) in formData.kaoguan" :key="index" >
                  <span >{{user.name}}{{user.phone}}<br/>({{user.num}})</span>
                  <a-icon type="close-circle" @click="kaoguanRemove(index)" />
                </div>

                <a @click="kaoguanPickerShow = true" v-show="!kaoguanPickerShow" href="#nogo">新增</a>
                <kaoguan-picker style="width: 300px; margin-right: 10px;"  :user_id="formData.user_id" :danwei_id="formData.danwei_id" @onSelect="onKaoguanAdd" v-show="kaoguanPickerShow" />
                <a @click="kaoguanPickerShow = false" v-show="kaoguanPickerShow" href="#nogo">取消</a>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="监督"
                      hasFeedback
              >
                <div v-for="(user,index) in formData.jiandu" :key="index" >
                  <span >{{user.name}}{{user.phone}}<br/>({{user.num}})</span>
                  <a-icon type="close-circle" @click="jianduRemove(index)" />
                </div>

                <a @click="jianduPickerShow = true" v-show="!jianduPickerShow" href="#nogo">新增</a>
                <jiandu-picker style="width: 300px; margin-right: 10px;"  :user_id="formData.user_id" :danwei_id="formData.danwei_id" @onSelect="onJianduAdd" v-show="jianduPickerShow" />
                <a @click="jianduPickerShow = false" v-show="jianduPickerShow" href="#nogo">取消</a>
              </a-form-item>
            </a-col>

            </a-row>

            <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="机构考官"
                      hasFeedback
              >
                <div v-for="(user,index) in formData.jigoukaoguan" :key="index" >
                  <span >{{user.name}}{{user.phone}}<br/>({{user.num}})</span>
                  <a-icon type="close-circle" @click="jigoukaoguanRemove(index)" />
                </div>

                <a @click="jigoukaoguanPickerShow = true" v-show="!jigoukaoguanPickerShow&&formData.jigoukaoguan==0" href="#nogo">新增</a>
                <kaoguan-picker style="width: 300px; margin-right: 10px;"  :user_id="formData.user_id" :danwei_id="formData.danwei_id" @onSelect="onjigouKaoguanAdd" v-show="jigoukaoguanPickerShow" />
                <a @click="jigoukaoguanPickerShow = false" v-show="jigoukaoguanPickerShow" href="#nogo">取消</a>
              </a-form-item>
            </a-col> 

            </a-row>


<!--          <a-row :gutter="48">-->
<!--            <a-col :md="48" :sm="24">-->
<!--          <a-form-item-->
<!--                  :labelCol="{-->
<!--          xs: { span: 12 },-->
<!--          sm: { span: 4 }}"-->
<!--                  :wrapperCol="{-->
<!--          xs: { span: 24 },-->
<!--          sm: { span: 12 }}"-->
<!--                  label="审核状态"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-radio-group v-model="formData.status" buttonStyle="solid">-->
<!--              <a-radio-button :value="0">未提交</a-radio-button>-->
<!--              <a-radio-button :value="1">待审核</a-radio-button>-->
<!--              <a-radio-button :value="2">审核通过</a-radio-button>-->
<!--              <a-radio-button :value="3">审核失败</a-radio-button>-->
<!--            </a-radio-group>-->
<!--          </a-form-item>-->
<!--              </a-col>-->
<!--            </a-row>-->
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否开启三个月时间限制"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="is_open_timelimit" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="强制购买服装"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="is_buy_clothes" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="考试状态"
                  hasFeedback
          >
            <a-radio-group v-model="formData.score_status" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">等待考试</a-radio-button>
              <a-radio-button :value="2">考试中</a-radio-button>
              <a-radio-button :value="3">考试结束</a-radio-button>
              <a-radio-button :value="4">确认分数</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="物料状态"
                  hasFeedback
          >
            <a-radio-group v-model="formData.goods_status" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
<!--              <a-radio-button :value="1">选择器材</a-radio-button>-->
<!--              <a-radio-button :value="2">完善收货信息</a-radio-button>-->
<!--              <a-radio-button :value="3">管理员确认金额</a-radio-button>-->
<!--              <a-radio-button :value="4">正在付款  </a-radio-button>-->
<!--              <a-radio-button :value="5">支付成功  </a-radio-button>-->
              <a-radio-button :value="6">已发货  </a-radio-button>
<!--              <a-radio-button :value="7">已安装  </a-radio-button>-->
<!--              <a-radio-button :value="8">完成  </a-radio-button>-->
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>


          <a-divider>费用信息</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(红)"
                      :extra="'结算价¥'+formData.kaoji_price_cash1"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price1',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(橙)"
                      :extra="'结算价¥'+formData.kaoji_price_cash2"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price2',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(黄)"
                      :extra="'结算价¥'+formData.kaoji_price_cash3"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price3',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(绿)"
                      :extra="'结算价¥'+formData.kaoji_price_cash4"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price4',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(青)"
                      :extra="'结算价¥'+formData.kaoji_price_cash5"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price5',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(蓝)"
                      :extra="'结算价¥'+formData.kaoji_price_cash6"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price6',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(紫)"
                      :extra="'结算价¥'+formData.kaoji_price_cash7"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price7',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(幼儿初)"
                      :extra="'结算价¥'+formData.kaoji_price_cash01"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price01',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(幼儿中)"
                      :extra="'结算价¥'+formData.kaoji_price_cash02"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price02',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费(幼儿高)"
                      :extra="'结算价¥'+formData.kaoji_price_cash03"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'kaoji_price03',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="服装费"
                      :extra="'结算价¥'+formData.clothes_price_cash"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'clothes_price',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级鞋费"
                      :extra="'结算价¥'+formData.shoes_price_cash"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'shoes_price',
          {rules: [{ required: true, message: '请输入考级费' }]}
        ]"
                          placeholder="请输入考级费"/>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="设置"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="settingVisible"
            @ok="handleSettingOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2" >

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级服结算价"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_clothes_price" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级鞋结算价"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_shoes_price" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>0元考级点结算价</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="红"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_1" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="橙"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_2" />
              </a-form-item>
            </a-col>

          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="黄"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_3" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="绿"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_4" />
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="青"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_5" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="蓝"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_6" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="紫"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_7" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="少儿初级"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_01" />
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="少儿中级"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_02" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="少儿高级"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price1_03" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>9800考级点结算价</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="红"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_1" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="橙"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_2" />
              </a-form-item>
            </a-col>

          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="黄"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_3" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="绿"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_4" />
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="青"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_5" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="蓝"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_6" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="紫"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_7" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="少儿初级"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_01" />
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="少儿中级"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_02" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="少儿高级"
                      hasFeedback
              >
                <a-input v-model="settingFormData.qcxj_kaoji_price2_03" />
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="settingVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleSettingOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="人员名单"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userVisible"
            @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table  
          :columns="userColumns" :dataSource="kaojiUserList" :pagination="userPagination"
                   @change="handleUserTableChange" 
                    :rowSelection="{ selectedRowKeys: selectedUserRowKeys, onChange: onSelectUserChange }"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="userSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="userSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.name}}
            </span>
            <template slot="action" slot-scope="text,record,index">
              <span>{{record.pay_status == 1 ? '未支付' : '已支付'}}</span>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="onEditUser(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteUserHandle(record)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </a-form>
      </a-spin>

      <template slot="footer">
        <a-popconfirm
        v-show="selectedUserRowKeys.length>0"
          title="删除后不可恢复,确定删除吗?"
          @confirm="userDeleteAll()"
          okText="确定"
          cancelText="取消"
        >
          <a-button type="default">
            <a-icon type="delete" />
            删除选中({{selectedUserRowKeys.length}})
          </a-button>
        </a-popconfirm>
        <a-button key="pay" @click="onPayShow">支付二维码</a-button>
        <a-upload
            :fileList="[]"
            accept=".xls,.xlsx"
            :customRequest="readFile"
            style="display: inline-block;margin:0 8px;"
        >
          <a-button>人员批量导入</a-button>
        </a-upload>
        <a-button key="download" @click="fahuoDownload">下载发货清单</a-button>
        <a-button key="download2" @click="memberDownload">下载人员信息表</a-button>
        <a-button key="cancel" @click="userVisible=false">关闭</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="orderVisible"
            @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单位"
                      hasFeedback
              >
                {{orderFormData.danwei}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="物料费"
                      hasFeedback
              >
                <a-input v-model="orderFormData.goodsprice" allowClear  placeholder="物料费"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考级费"
                      hasFeedback
              >
                <a-input v-model="orderFormData.memberprice" allowClear  placeholder="考级费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="应付"
                      hasFeedback
              >
                <a-input style="width: 70%; margin-right: 10px" v-model="orderFormData.pay_price" allowClear  placeholder="应付金额"/>
                <a-button @click="refreshPrice"  >刷新</a-button>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上实付"
                      hasFeedback
              >
                {{orderFormData.payed_price}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上支付时间"
                      hasFeedback
              >
                {{orderFormData.pay_time_str}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="支付状态"
                      hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="应结算"
                      hasFeedback
              >
                <a-input v-model="orderFormData.cash_price" allowClear  placeholder="应结算"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已结算"
                      hasFeedback
              >
                <a-input v-model="orderFormData.cashed_price" allowClear  placeholder="已结算"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="结算状态"
                      hasFeedback
              >
                <a-radio-group v-model="orderFormData.cash_status" button-style="solid">
                  <a-radio-button :value="1">
                    未结算
                  </a-radio-button>
                  <a-radio-button :value="2">
                    已结算
                  </a-radio-button>
                  <a-radio-button :value="3">
                    结算中
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="管理员备注"
                      hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size />
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="人员操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userFormVisible"
            @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="身份证"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>


          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="等级"
                      :extra="'¥'+userFormData.kaoji_price1+'(红) , ¥'+userFormData.kaoji_price2+'(橙) , ¥'+userFormData.kaoji_price3+'(黄) , ¥'+userFormData.kaoji_price4+'(绿) , ¥'+userFormData.kaoji_price5+'(青) , ¥'+userFormData.kaoji_price6+'(蓝) , ¥'+userFormData.kaoji_price7+'(紫) , ¥'+userFormData.kaoji_price01+'(幼儿初) , ¥'+userFormData.kaoji_price02+'(幼儿中) , ¥'+userFormData.kaoji_price03+'(幼儿高)'"
                      hasFeedback
              >

                <a-select
                        showSearch
                        optionFilterProp="title"
                        v-model="userFormData.grade"
                        placeholder="星级"
                        allowClear
                >
                <a-select-option     title="幼儿初" value="幼儿初">幼儿初</a-select-option>
                <a-select-option     title="幼儿中" value="幼儿中">幼儿中</a-select-option>
                <a-select-option    title="幼儿高" value="幼儿高">幼儿高</a-select-option>
                  <a-select-option   title="红" value="红">红</a-select-option>
                  <a-select-option   title="橙" value="橙">橙</a-select-option>
                  <a-select-option   title="黄" value="黄">黄</a-select-option>
                  <a-select-option   title="绿" value="绿">绿</a-select-option>
                  <a-select-option   title="青" value="青">青</a-select-option>
                  <a-select-option   title="蓝" value="蓝">蓝</a-select-option>
                  <a-select-option   title="紫" value="紫">紫</a-select-option>
                </a-select>

              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

              <a-form-item
                      label="证件照片"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
              >
                <pic-uploader
                        :file-list="userFormData.pic"
                />
              </a-form-item>
            </a-col>



          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="家长姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'famliy_name',
              {rules: []}
            ]"
                          placeholder="请输入家长姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="家长身份证"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'famliy_num',
              {rules: [ ]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系方式"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: []}
            ]"
                          placeholder="请输入联系方式"/>
              </a-form-item>
            </a-col>


          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="衣服尺码"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'csize',
              {rules: []}
            ]"
                          placeholder="请输入衣服尺码"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="鞋子尺码"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'footsize',
              {rules: [ ]}
            ]"
                          placeholder="请输入鞋子尺码"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="购买衣服"
                      :extra="'¥'+userFormData.clothes_price"
                      hasFeedback
              >
                <r-switch  :formData="userFormData" field="buyc"  :disabled="userFormData.pay_status==2"  :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="购买鞋子"
                      :extra="'¥'+userFormData.shoes_price"
                      hasFeedback
              >
                <r-switch  :formData="userFormData" field="buys" :disabled="userFormData.pay_status==2" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="错误信息"
        :width="600"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="showError"
    >
      <div v-for="item in errorMsg">{{item}}</div>
      <template slot="footer">
        <a-button key="cancel" @click="showError = false">取消</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false"
        title="批量上传"
        :width="600"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="showLoading"
    >
      <template>
        <div style="text-align: center">
          <a-progress type="circle" :percent="progress" />
        </div>
      </template>
      <template slot="footer">
        <a-button key="cancel" @click="showLoading = false">取消</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="支付二维码"
        :width="600"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll','text-align': 'center'}"
        v-model="showPay"
    >
      <img :src="payRow.ewm" alt="" style="width: 360px">
      <template slot="footer">
        <a-button key="cancel" @click="showPay = false">取消</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量生成"
        v-model="taskInfoShow"
    >
      <a-badge status="success" :text="'校验成功 '+(taskInfo.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'校验失败 '+(taskInfo.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo.members.length) "/> 
      <p v-show="taskInfo.errors.length>0" >存在以下错误，请修正后重新上传 </p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="error in taskInfo.errors">{{error}}</p>
      </div>
      <a-progress :percent="taskInfo.percent"/>
      </p>
    </a-modal>

  </a-card>
  </template>

  <script>
  import XLSX from "xlsx";
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import KaoguanPicker from '@/components/KaoguanPicker/'
  import JianduPicker from '@/components/JianduPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import RSwitch from '@/components/RSwitch/'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import setting from '@/config/setting'
  import { getApplyList ,getApplyDetail,editApply ,getApplyMemberList,applyDelete ,getSetting,setSetting,getApplyOrderDetail,editApplyOrder ,getApplyUserDetail,deleteApplyUser,deleteApplyUsers,editApplyUser,refreshOrder, addMemberAll,getApplyOrderUnPayDetail, checkApplyMemberOK} from '@/api/qcxj'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      RSwitch,
      KaoguanPicker,
      JianduPicker,
    },
    data () {
      return {
        areaOptions,
        taskInfoShow: false,
        errorMsg: false,
        showError: false,
        showPay: false,
        showLoading: false,
        progress: 0,
        settingVisible: false,
        kaoguanPickerShow: false,
        jianduPickerShow: false,
        userFormVisible: false,
        orderVisible: false,
        userVisible: false,
        visible: false,
        jigoukaoguanPickerShow:false,
        saveLoading:false,
        scoreTotal: 0, //带确认考级数量
        payRow: {},
        taskInfo: {
          members: [],
          errors: [],
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          percent: 0,
          doing: false,
        },
        formData:{
          id:0,
          danwei:'',
          datetitle_moment:null,
          datetitle:'',
          resultszip:[],
          kaoguan:[],
          jigoukaoguan:[],
          jiandu:[],
          namekeys:[],
          areas:[],
          is_open_timelimit: 1,
          is_buy_clothes: 1,
        },
        formDataRs: {
          grade: '',
          csize: '',
          num: '',
          numtype: 1,
          birthday:'',
          sex:1,
          is_exam_continue: 2,
          kaoji_id: this.$route.query.id,
          share_id: 0,
          name: '',
          score_total: 0
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form2: this.$form.createForm(this),
        form3: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          id:0,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '考官/监督',
            dataIndex: 'kaoguan',
            scopedSlots: { customRender: 'kaoguan' },
          },
          {
            title: '进度',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 220,
            scopedSlots: { customRender: 'action' },
          }
        ],


        //领取人员表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '姓名',
            dataIndex: 'name',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '价格',
            width:'150px',
            dataIndex: 'price'
          },
          {
            title: '星级',
            width:'100px',
            dataIndex: 'grade',
            filters: [
              {
                text: '幼儿初',
                value: '幼儿初'
              },
              {
                text: '幼儿中',
                value: '幼儿中'
              },
              {
                text: '幼儿高',
                value: '幼儿高'
              },
              {
                text: '红',
                value: '红'
              }, 
              {
                text: '橙',
                value: '橙'
              },
              {
                text: '黄',
                value: '黄'
              },
              {
                text: '绿',
                value: '绿'
              },
              {
                text: '青',
                value: '青'
              },
              {
                text: '蓝',
                value: '蓝'
              },
              {
                text: '紫',
                value: '紫'
              }
              ],
            filterMultiple:false,
          },
          {
            title: '参加时间',
            width:'150px',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          }
        ],
        userPagination:{
          pageSize: 30,
          p: 1,
          showSizeChanger:true,
          onShowSizeChange: (current,pageSize) => this.changeUserPageSize(pageSize,current),
          showTotal: total => {
            return '总计' + total + '条'
          }
        },
        userQuery:{
          kaoji_id:0,
          status:0,
          pageNo:1,
          pageSize:30,
          keywords:undefined
        },
        kaojiUserList:[],
        startNum: 3,
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              this.scoreTotal = res.data.score_total
              return res.data
            })
        },
        orderFormData:{},
        selectedRowKeys: [],
        selectedUserRowKeys: [],
        selectedRows: [],
        selectedUserRows: [],
        settingFormData:{
          qcxj_clothes_price:'',
          qcxj_shoes_price:'',

          qcxj_kaoji_price1_1:'',
          qcxj_kaoji_price1_2:'',
          qcxj_kaoji_price1_3:'',
          qcxj_kaoji_price1_4:'',
          qcxj_kaoji_price1_5:'',
          qcxj_kaoji_price1_6:'',
          qcxj_kaoji_price1_7:'',

          qcxj_kaoji_price1_01:'',
          qcxj_kaoji_price1_02:'',
          qcxj_kaoji_price1_03:'',

          qcxj_kaoji_price2_1:'',
          qcxj_kaoji_price2_2:'',
          qcxj_kaoji_price2_3:'',
          qcxj_kaoji_price2_4:'',
          qcxj_kaoji_price2_5:'',
          qcxj_kaoji_price2_6:'',
          qcxj_kaoji_price2_7:'',

          qcxj_kaoji_price2_01:'',
          qcxj_kaoji_price2_02:'',
          qcxj_kaoji_price2_03:'',
        },
        userFormData:{
          id:0,
          pic:[]
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.queryParam.id = this.$route.query.id
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.namekey){
              res.data.namekeys = [res.data.namekey.substring(0,2)+'0000',res.data.namekey.substring(0,4)+'00',res.data.namekey];
            }else{
              res.data.namekeys = [];
            }
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.datetitle_moment = moment(res.data.datetitle,'YYYY-MM-DD');;
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      onSetting(){
        let self = this
        this.settingVisible = true
        getSetting( ).then(res => {
          self.settingFormData = res.data;
        // console.log(this.mdl)
      })
      },

      // 待确认分数
      onScoreConfirm() {
        let self = this;
        self.queryParam.score_status = '3'
        self.$refs.table.refresh(false)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      deleteHandle(record){
        let self = this
        applyDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editApply({
              id:self.formData.id,
              namekey:self.formData.namekeys[self.formData.namekeys.length-1],
              datetitle:self.formData.datetitle_moment.format('YYYY-MM-DD'),
              members:values.members,
              danwei:values.danwei,
              yundongyuanrenshu:values.yundongyuanrenshu,
              area:self.formData.areas[self.formData.areas.length-1],
              address:values.address,
              address_wuliao:values.address_wuliao,
              resultszip:self.formData.resultszip,
              kaoguan:self.formData.kaoguan,
              jigoukaoguan:self.formData.jigoukaoguan,
              jiandu:self.formData.jiandu,
              status:self.formData.status,
              is_open_timelimit:self.formData.is_open_timelimit,
              is_buy_clothes:self.formData.is_buy_clothes,
              score_status:self.formData.score_status,
              goods_status:self.formData.goods_status,
              kaoji_price1:values.kaoji_price1,
              kaoji_price2:values.kaoji_price2,
              kaoji_price3:values.kaoji_price3,
              kaoji_price4:values.kaoji_price4,
              kaoji_price5:values.kaoji_price5,
              kaoji_price6:values.kaoji_price6,
              kaoji_price7:values.kaoji_price7,
              kaoji_price01:values.kaoji_price01,
              kaoji_price02:values.kaoji_price02,
              kaoji_price03:values.kaoji_price03,
              clothes_price:values.clothes_price,
              shoes_price:values.shoes_price,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      // 增改 处理
      handleSettingOk(e) {
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            self.saveLoading = true;
            setSetting(self.settingFormData).then(res => {
              self.$message.success('修改成功')
              self.settingVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      handleUserManage(record) {
        let self = this
        self.userQuery.kaoji_id = record.id;
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.fetchUserList();
        this.userVisible = true
      },


      fetchUserList(){
        let self = this
        getApplyMemberList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.kaojiUserList = res.data.list
//          self.userPagination.total = res.data.total
          const pagination = { ...this.userPagination }
          pagination.total = res.data.total
          console.log('pagination',pagination)
          // self.userPagination.total = res.data.total
          self.userPagination = pagination
        })
      },

      userSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchUserList();
      },
      userSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.userQuery.keywords = undefined;
        self.fetchUserList();
      },
      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.grade){
          that.userQuery.grade = filters.grade[0];
        }else{
          that.userQuery.grade = '';
        }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.userQuery.pageNo = pagination.current;

        pager.p = pagination.current
        that.userPagination = pager
        that.fetchUserList();
      },


      jigoukaoguanRemove(index){
        console.log('jigoukaoguanRemove',index);
        this.formData.jigoukaoguan.splice(index,1);
        this.jigoukaoguanPickerShow = false;
      },
      onjigouKaoguanAdd(value){
        console.log('onjigouKaoguanAdd',value);
        let exist = this.formData.jigoukaoguan.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.jigoukaoguanPickerShow = false;
          return ;
        }
        this.formData.jigoukaoguan.push(value);
        this.jigoukaoguanPickerShow = false;
      },

      kaoguanRemove(index){
        console.log('kaoguanRemove',index);
        this.formData.kaoguan.splice(index,1);
        this.kaoguanPickerShow = false;
      },
      onKaoguanAdd(value){
        console.log('onKaoguanAdd',value);
        let exist = this.formData.kaoguan.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.kaoguanPickerShow = false;
          return ;
        }
        this.formData.kaoguan.push(value);
        this.kaoguanPickerShow = false;
      },
      jianduRemove(index){
        console.log('jianduRemove',index);
        this.formData.jiandu.splice(index,1);
        this.jianduPickerShow = false;
      },
      onJianduAdd(value){
        console.log('onJianduAdd',value);
        let exist = this.formData.jiandu.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.jianduPickerShow = false;
          return ;
        }
        this.formData.jiandu.push(value);
        this.jianduPickerShow = false;
      },


      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    onSelectUserChange (selectedRowKeys, selectedRows) {
        this.selectedUserRowKeys = selectedRowKeys
        this.selectedUserRows = selectedRows
        console.log(selectedRowKeys, selectedRows)
      },


      handleOrderCancel(){
        this.orderVisible = false
      },
      handleOrderEdit(record){
        let self = this
        getApplyOrderDetail({ baoming_id: record.id }).then(res => {
          self.orderVisible = true
          setTimeout(() =>{
            self.orderFormData.id = record.id;
            console.log('handleEdit')
            self.orderFormData = { ...res.data };
          },200)
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
        // console.log(this.mdl)
      },
      handleOrderOk(e) {
        let self = this;
        e.preventDefault();

        self.saveLoading = true;
        editApplyOrder({
          id:self.orderFormData.id,
          baoming_id:self.orderFormData.baoming_id,
          status:self.orderFormData.status,
          adminnote:self.orderFormData.adminnote,
          memberprice:self.orderFormData.memberprice,
          goodsprice:self.orderFormData.goodsprice,
          pay_price:self.orderFormData.pay_price,
          cash_status:self.orderFormData.cash_status,
          cash_price:self.orderFormData.cash_price,
          cashed_price:self.orderFormData.cashed_price,
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh(false)
          self.orderVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },

      onEditUser(record){
        let self = this
        this.userFormVisible = true
        getApplyUserDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form3.setFieldsValue({ ...res.data })
            self.userFormData.id = record.id;
            self.userFormData = { ...res.data };
          },200)
        })
      },
      deleteUserHandle(record){
        let self = this
        deleteApplyUser({ id: record.id }).then(res => {
          self.fetchUserList();
        })
      },
      handleUserFormCancel(){
        this.userFormVisible = false
      },

      onPayShow() {
        let self = this
        getApplyOrderUnPayDetail({ baoming_id: this.userQuery.kaoji_id }).then(res => {
          self.showPay = true
          self.payRow = res.data
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      fahuoDownload(){
        window.open(setting.apiBaseURL+'/adminapi/qcxj/fahuoword?baoming_id='+this.userQuery.kaoji_id);
      },
      memberDownload(){
        window.open(setting.apiBaseURL+'/adminapi/qcxj/memberDownload?baoming_id='+this.userQuery.kaoji_id);
      },
      // 增改 处理
      handleUserFormOk(e) {
        let self = this;
        e.preventDefault()
        this.form3.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.userFormData)
            self.saveLoading = true;
              editApplyUser({
                id:self.userFormData.id,
                name:values.name,
                num:values.num,
                grade:self.userFormData.grade,
                pic:self.userFormData.pic,
                buyc:self.userFormData.buyc,
                buys:self.userFormData.buys,
                footsize:values.footsize,
                csize:values.csize,
                famliy_name:values.famliy_name,
                famliy_num:values.famliy_num,
                phone:values.phone,
              }).then(res => {
                self.$message.success('修改成功')

                self.fetchUserList();

                self.userFormVisible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })

          }
        })
      },

      refreshPrice(){
        let self = this
        refreshOrder({ baoming_id: self.orderFormData.baoming_id }).then(res =>{
          self.handleOrderEdit({
            id:self.orderFormData.baoming_id
          });
        })
      },


      readFiles(evt) {
        console.log('------readFile------', evt)
        var that = this;
        that.errorMsg = []
        that.index = 0

        that.showTemplate = false

        let files = {0: evt.file}

        const fileReader = new FileReader();
        fileReader.onload = (ev) => {
          try {
            const data = ev.target.result;
            const workbook = XLSX.read(data, {
              type: 'binary'
            });
            const wsname = workbook.SheetNames[0];//取第一张表
            var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

            if (that.startNum) {
              list = list.splice(that.startNum, list.length)
            }

            that.listData = list
            // let listData = list.filter(row => {
            //   return row.hasOwnProperty("__EMPTY");
            // })
            console.log('onGetData', list)
            // return
            that.formatData()

          } catch (e) {
            console.log(e)
            return false;
          }
        };
        fileReader.readAsBinaryString(files[0]);
      },

      formatData() {
        let that = this
        that.showLoading = true
        that.listData.map((row) => {
          that.addRow(row)
        })
        return ;
      },

      addRow(row) {
        console.log('addRow',row);
        let that = this
        let memberRow = {
          grade: '',
          csize: '',
          num: '',
          numtype: 1,
          birthday:'',
          sex:1,
          is_exam_continue: 2,
          kaoji_id: 0,
          share_id: 0,
          name: '',
          score_total: 0
        }
        memberRow.name = row['__EMPTY']
        memberRow.sex = row['__EMPTY_1'] === '男'? 1 : 2
        memberRow.phone = row['__EMPTY_2'] ? row['__EMPTY_2'] : ''
        memberRow.num = row['__EMPTY_3'] ? row['__EMPTY_3'] : ''
        memberRow.totalscore = row['__EMPTY_4'] ? row['__EMPTY_4'] : ''
        memberRow.kaoji_id = that.userQuery.kaoji_id

        let grade = '红'
        if(row['__EMPTY_5'] === 1) {
          grade = '红';
        } else if(row['__EMPTY_6'] === 1) {
          grade = '橙';
        }else if(row['__EMPTY_7'] === 1) {
          grade = '黄';
        }else if(row['__EMPTY_8'] === 1) {
          grade = '绿';
        }else if(row['__EMPTY_9'] === 1) {
          grade = '青';
        }else if(row['__EMPTY_10'] === 1) {
          grade = '蓝';
        }else if(row['__EMPTY_11'] === 1) {
          grade = '紫';
        }
        memberRow.grade =grade

        console.log(memberRow)
        // return
        that.kaojiMemberAdd(memberRow)
      },

      kaojiMemberAdd(memberRow) {
        let that = this

        addMemberAll(memberRow).then(res => {
          if (res[600]) {
            that.errorMsg.push(res[600])
          }
          that.getProgress()
        }).catch(err =>{
          console.log(err)
          if (err.code === 600) {
            that.errorMsg.push(err.msg)
          }
          that.getProgress()
        })
      },

      getProgress() {
        let that = this
        that.index += 1

        let index = that.index,
            list = that.listData

        // console.log(that.errorMsg, index, list.length)

        that.progress = parseInt((index / list.length) * 100);
        if (index === list.length) {
          that.showLoading = false
          that.fetchUserList()

          if (that.errorMsg.length > 0) {
            // 唤起弹框
            that.showError = true
          } else {
            that.$message.success('批量导入成功')
          }
        }
      },

      readFile(evt) {
        let that = this
        let formdata = new FormData()
        let file = evt.file

        console.log(file)
        formdata.append('upfile', file)
        formdata.append('action', 'test')


      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson',tabJson);
          let userList = [];

 

          tabJson[0].sheet.map((row,index) =>{
            if(index>2 && row['__EMPTY_3']){
              let memberRow = {
                grade: '',
                csize: '',
                num: '',
                numtype: 1,
                birthday:'',
                sex:1,
                is_exam_continue: 2,
                kaoji_id: 0,
                share_id: 0,
                name: '',
                score_total: 0
              }
              memberRow.name = row['__EMPTY']
              memberRow.sex = row['__EMPTY_1'] === '男'? 1 : 2
              memberRow.phone = row['__EMPTY_2'] ? row['__EMPTY_2'] : ''
              memberRow.num = row['__EMPTY_3'] ? row['__EMPTY_3'] : ''
              memberRow.numtype = row['__EMPTY_4'] === '护照' ? 2 : 1
              memberRow.totalscore = row['__EMPTY_5'] ? row['__EMPTY_5'] : ''
              memberRow.kaoji_id = that.userQuery.kaoji_id
              memberRow.num = this.ClearJson(memberRow.num+'')
              



              let grade = '红'
              if(row['__EMPTY_6'] == 1) {
                grade = '红';
              } else if(row['__EMPTY_7'] == 1) {
                grade = '橙';
              }else if(row['__EMPTY_8'] == 1) {
                grade = '黄';
              }else if(row['__EMPTY_9'] == 1) {
                grade = '绿';
              }else if(row['__EMPTY_10'] == 1) {
                grade = '青';
              }else if(row['__EMPTY_11'] == 1) {
                grade = '蓝';
              }else if(row['__EMPTY_12'] == 1) {
                grade = '紫';
              }else if(row['__EMPTY_13'] === 1) {
                grade = '幼儿初';
              }else if(row['__EMPTY_14'] === 1) {
                grade = '幼儿中';
              }else if(row['__EMPTY_15'] === 1) {
                grade = '幼儿高';
              }
              memberRow.grade =grade
              memberRow.grades =[grade]
              

              userList.push(memberRow)

            }
          })

          let numtograde = {}
          userList.map(item =>{

            if(typeof numtograde[item['num']] == 'undefined'){
                numtograde[item['num']] = [item.grade]
              }else{
                numtograde[item['num']].push(item.grade)
              }
          })

          userList.map(item =>{
            item.grades = numtograde[item['num']]
          })

          // console.log('numtograde',numtograde);
          // return
          console.log('userList',userList);
          // return ;

          that.taskInfo = {
            members: userList,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            errors: [],
            doing: true,
          }
          that.taskInfoShow = true;
          that.doTask(that.taskInfo);

        }});

      /*
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })*/
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

   ClearJson(str) {
                if (str != null && str != "") {
                    return str.replace(/(\t|\r|\n|\s|\b|\f|\"|\u)/ig, "").replace(/(\\)/ig, "");
                }
 
                return "";
            } ,

    file2Xce(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader()
        reader.onload = function(e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file) // 传统input方法
      })
    },

    doTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.members.length) {
        taskInfo.doing = false;
        //结束
        if(taskInfo.fcount==0){
        // return 
          addMemberAll({
            list:JSON.stringify(taskInfo.members),
          }).then( res =>{
            that.taskInfoShow = false;
            that.$message.success('上传成功')
            that.fetchUserList()
          });
        }
        return false;
      }
      checkApplyMemberOK({
        name: taskInfo.members[taskInfo.currentIndex].name,
        num: taskInfo.members[taskInfo.currentIndex].num,
        grade: taskInfo.members[taskInfo.currentIndex].grade,
        grades: taskInfo.members[taskInfo.currentIndex].grades,
        numtype: taskInfo.members[taskInfo.currentIndex].numtype,
        birthday:'',
        sex:1,
        is_exam_continue: 2,
        kaoji_id: that.userQuery.kaoji_id,
        share_id: 0,
        score_total: 0
      }).then(res => {
        console.log('res.data',res.data)
        if(res.data.length>0){
          taskInfo.fcount++;
          taskInfo.errors = taskInfo.errors.concat(res.data);
          taskInfo.currentIndex++;
        }else{
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == (taskInfo.members.length)) {
          }
        }
        taskInfo.percent = (((taskInfo.currentIndex) / (taskInfo.members.length + 1)) * 100).toFixed(1);
        that.doTask(taskInfo)
      }).catch(err => {
        taskInfo.fcount++;
        taskInfo.currentIndex++;
        taskInfo.percent = (((taskInfo.currentIndex) / (taskInfo.members.length + 1)) * 100).toFixed(1);
        that.doTask(taskInfo)
      });
 
    },


      //  
      userDeleteAll() { 
        let self = this 
        deleteApplyUsers({
          ids: self.selectedUserRowKeys,
        }).then((res) => {
          self.fetchUserList();
          self.selectedUserRowKeys = []
          self.selectedUserRows = []
          self.$message.success("删除成功");  
        });
      },
      changeUserPageSize(pageSize,current){
        this.userPagination.pageSize = pageSize 
        this.userQuery.pageSize = pageSize 
      }


    },
    filters:{
    },
    watch: {
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
